import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyBoOV_3ANt-gpBVXlbJRExeMZ84kU7ZbmU",
  authDomain: "planora-cea92.firebaseapp.com",
  projectId: "planora-cea92",
  storageBucket: "planora-cea92.firebasestorage.app",
  messagingSenderId: "124161210844",
  appId: "1:124161210844:web:eb85d0cad66d700b3c7719"
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
export const googleProvider = new GoogleAuthProvider()
